import React, {Component} from 'react';
import sanitizeHtml from 'sanitize-html';
import PropTypes from 'prop-types';

import {Card} from 'semantic-ui-react';

export default class CardHTML extends Component {

    shouldComponentUpdate({html}) {
        return html !== this.props.html;
    }

    render() {
        const {html} = this.props,
            getHtml = () => ({__html: sanitizeHtml(html)});
        return <Card className="CardHTML" fluid={true}>
            <Card.Content>
                <div className="CardHTML-content" dangerouslySetInnerHTML={getHtml()}/>
            </Card.Content>
        </Card>;
    }
}

CardHTML.propTypes = {
    html: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/card/HTML.js